/**
 * ScrollToTop - Reset scroll position on route changes
 *
 * Place inside router to fire on every navigation,
 * including programmatic navigate() calls and back/forward.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Delay scroll reset until after transition animation completes
    const t = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 300);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
